export class Periodo {
  anio: number;
  mes: number;

  static fromDate(date: Date): Periodo {
    return new Periodo(date.getMonth() + 1, date.getFullYear());
  }

  constructor(mes: any, anio: any) {
    this.mes = +mes;
    this.anio = +anio;
  }

  isValid(): boolean {
    if (isNaN(this.anio) || isNaN(this.mes)) {
      return false;
    }
    if (!this.mes || !this.anio) {
      return false;
    }
    if (this.mes < 1 || this.mes > 12) {
      return false;
    }
    return true;
  }

  isCurrentPeriod(): boolean {
    const date = new Date();
    return this.anio === date.getFullYear() && this.mes === date.getMonth() + 1;
  }
}
